export default __webpack_public_path__ + "static/media/entenda_1000.1ddd5f2e.webp";